export default __webpack_public_path__ + "static/media/aprroach.915faa73.webp";